import React, { FC, useCallback } from 'react';

import { useFormContext } from 'react-hook-form';

import { Checkbox } from '@appcharge/shared-ui';

const HidePlayerAvailabilityCheckbox: FC = (): React.ReactElement => {
  const form = useFormContext();
  const hidePlayerAvailability = form.watch('hidePlayerAvailability');

  const handleChange = useCallback(
    (checked: boolean): void => {
      form.setValue('hidePlayerAvailability', checked, { shouldDirty: true });
    },
    [form]
  );

  return (
    <Checkbox
      checked={hidePlayerAvailability}
      onCheckedChange={handleChange}
      label="Hide Availability"
    />
  );
};

export { HidePlayerAvailabilityCheckbox };
